import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
// import { Route } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "../footer/Footer";
import Navbar from "../header/Header";

// Routes

import Home from "../home";

// About
import About from "../About";
import AboutOwner from "../About Owner";

// Contact Us
import ContactUs from "../Contact Us";

// Education
import Courses from "../Courses/tabs";
import Schedule from "../schedue/Schedule";

// Laboratory
import AboutLab from "../AboutGGILabortary/About";
import LabReport from "../LabReports/tabs";
import Price from "../Price/index";
import Terms from "../Terms/index";

// Gemology
import Gemology from "../Gemology/index";
import YourBirthStone from "../YourBirthStone";

// Appraisal
import Appraisal from "../Appraisal";

// Education
import Education from "../Educaton";
import Test from "../Test";
import NotFound from "./NotFound";

// Routes End

function Routes() {
  let [path, setPath] = useState("");
  useEffect(() => {
    setPath(window.location.pathname.split("/")[1]);
  }, [window.location.pathname]);
  console.log(window.location.pathname.split("/")[1]);

  const allRoutes = [
    {
      route: "/",
      component: Home,
    },
    {
      route: "/about",
      component: About,
    },
    {
      route: "/about/found-and-ceo",
      component: AboutOwner,
    },
    {
      route: "/services/main-services",
      component: LabReport,
    },
    {
      route: "/contact-us",
      component: ContactUs,
    },
    {
      route: "/gemological-education",
      component: Education,
    },
    {
      route: "/gemological-education/courses",
      component: Courses,
    },
    {
      route: "/gemological-education/schedule",
      component: Schedule,
    },
    {
      route: "/laboratory/about-ggi-laboratory",
      component: AboutLab,
    },
    {
      route: "/laboratory/lab-reports",
      component: LabReport,
    },
    {
      route: "/laboratory/lab-service-fee",
      component: Price,
    },
    {
      route: "/laboratory/terms-and-conditions",
      component: Terms,
    },
    {
      route: "/gemology/YourBirthStone",
      component: YourBirthStone,
    },
    {
      route: "/gemology",
      component: Gemology,
    },
    {
      route: "/appraisal",
      component: Appraisal,
    },
    {
      route: "/Test",
      component: Test,
    },
  ];

  // useEffect(() => {
  // 	allRoutes.map((a) => {
  // 		a.route !== window.location.pathname ?
  // 			console.log('not found') :
  // 			console.log('found')

  // 	})
  // }, [])

  //   let breakMap = true;
  return (

    <Router>
      {path !== "Certificate" ? <Navbar /> : null}

      {/* {} */}
      {/* render all route */}
      {allRoutes.map((a, index) => {
        return (

          <Route key={index} path={a.route} exact component={a.component} />

        );
      })}

      {/* if current route doesnot exist in allroutes then renders notfound */}

      {allRoutes.filter((obj) => obj.route.toLowerCase() === window.location.pathname.toLowerCase())
        .length === 0 ? (
        <>
          {window.location.pathname.split("/")[1] !== "Certificate" ? (

            <Route path="*" component={NotFound} />

          ) : null}
        </>
      ) : null}
      {path !== "Certificate" ? <Footer /> : null}
    </Router>
    // let breakMap = true;
    // return (
    // 	<Route>
    // 	<Route path='/'  component={Home} />
    // 	<Route path='/laboratory/lab-service-fee'  component={Price} />
    // 	<Route path='/laboratory/lab-reports' component={LabReport} />
    // 	<Route path='/laboratory/about-ggi-laboratory' component={AboutLab}  />
    // 	<Route path='/gemological-education/schedule'  />
    // 	<Route path='/laboratory/terms-and-conditions' />
    // 	<Route path='/gemology/YourBirthStone' component={YourBirthStone} />
    // 	<Route path='/gemology' component={Gemology} />
    // 	<Route path='/appraisal' component={Appraisal} />
    // 	<Route path='/Certificate/:entryNumber'  component={Certificate}  />
    // 	<Route path='/contact-us' component={ContactUs} />
    // 	<Route path='/gemological-education' component={Education} />
    // 	<Route path='/about'  component={About} />
    // 	<Route path='/gemological-education/courses' component={Courses}  />
    // 	<Route path='/about/found-and-ceo' component={AboutOwner} />
    // 	<Route path='/Services/Main Services'  component={LabReport} />
    // 	<Route path='/Test' component={<Test/>} />

    // </Route>
    // );

    // return (
    // 	<div className="Routes">
    // 		{path !== "Certificate" ? <Navbar /> : null}
    // 		{/* Home */}
    // 		<Route path="/" exact component={Home} />

    // 		{/* About */}
    // 		<Route path="/about" exact component={About} />
    // 		<Route path="/about/found-and-ceo" exact component={AboutOwner} />

    // 		{/* Main Services */}
    // 		<Route path="/Services/Main Services" exact component={LabReport} />

    // 		{/* Contact Us */}
    // 		<Route path="/contact-us" exact component={ContactUs} />

    // 		{/* Education */}
    // 		<Route path="/gemological-education" exact component={Education} />
    // 		<Route path="/gemological-education/courses" exact component={Courses} />
    // 		<Route path="/gemological-education/schedule" exact component={Schedule} />

    // 		{/* Laboratry */}
    // 		<Route path="/laboratory/about-ggi-laboratory" exact component={AboutLab} />
    // 		<Route path="/laboratory/lab-reports" exact component={LabReport} />
    // 		<Route path="/laboratory/lab-service-fee" exact component={Price} />
    // 		<Route path="/laboratory/terms-and-conditions" exact component={Terms} />

    // 		{/* Gemology */}
    // 		<Route path="/gemology/YourBirthStone" exact component={YourBirthStone} />
    // 		<Route path="/gemology" exact component={Gemology} />

    // 		{/* Appraisal */}
    // 		<Route path="/appraisal" exact component={Appraisal} />

    // 		{/* Appraisal */}
    // 		<Route path="/Certificate/:entryNumber" exact component={Certificate} />
    // 		<Route component={NotFound} />
    // 		{path !== "Certificate" ? <Footer /> : null}
    // 	</div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
